//REACT LIBRARIES
import React from 'react'
import {render} from 'react-dom'
import {Router, Route, hashHistory, IndexRedirect} from 'react-router'
import {syncHistoryWithStore} from 'react-router-redux';

//OTHER LIBRARIES FLUX LIBRARIES
import {Provider} from 'react-redux'

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(hashHistory, store)

import store from 'flux'

//app

import App from "./app";

/* PAGES */
import PersonalInformation from "./pages/personal-information";
import EmploymentDesired from "./pages/employment-desired";
import Education from "./pages/education";
import EmploymentHistory from "./pages/employment-history";
import Complete from "./pages/complete";

const transitionHandler = (transistion) => {
		var title = document.getElementById("application-title");
		if (title) {
				title.scrollIntoView();
		}
		reportToGA();
}

const reportToGA = () => {
		let hash = window
				.location
				.hash
				.split("?")[0];
		if (typeof ga !== 'undefined') {
				ga('set', 'page', window.location.pathname + hash);
				ga('send', 'pageview');
		} else {
				setTimeout(function () {
						if (typeof ga !== 'undefined') {
								ga('set', 'page', window.location.pathname + hash);
								ga('send', 'pageview');
						}
				}, 2000);
		}
};

console.log(store.getState().config.theater);

//ROUTING FOR THE APP
if (store.getState().config.theater) {
		render((
				<Provider store={store}>
						<Router history={history}>
								<Route path="/" onChange={reportToGA} component={App}>
										<IndexRedirect to="personal-information"/>
										<Route
												path="personal-information"
												component={PersonalInformation}
												onEnter={transitionHandler}/>
										<Route
												path="employment-desired"
												component={EmploymentDesired}
												onEnter={transitionHandler}/>
										<Route path="education" component={Education} onEnter={transitionHandler}/>
										<Route
												path="employment-history"
												component={EmploymentHistory}
												onEnter={transitionHandler}/>
										<Route path="complete" component={Complete} onEnter={transitionHandler}/>
								</Route>
						</Router>
				</Provider>
		), document.getElementById("employment-application"));
} else {
		render((
				<div id="employment-application-page">
						<img className="img-responsive hidden-xs" src="./images/Theatre-Hero.png"/>
						<div className="container">
								<h1 id="application-title">Employment Application</h1>
								<div>
										Please visit our
										<a href="/about-us/employment">careers page</a>
										to browse positions, select a theatre, and submit an application.
								</div>
						</div>
				</div>
		), document.getElementById("employment-application"));
}
